import {
  Button,
  Divider,
  FormControl,
  Grid,
  InputAdornment,
  Paper,
  TextField,
  Typography,
  Box,
  Container,
} from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { useEffect, useState } from "react";
import { FID_LOGO } from "../DrawerAppBar";
import { Link, useNavigate } from "react-router-dom";
import AuthService from "../../../service/AuthService";
import useToast from "../../../hooks/useToast";
import { isValidEmail } from "../../../Helpers/utilsHelper";
import PermIdentityOutlinedIcon from "@material-ui/icons/PermIdentityOutlined";
import LockOutlinedIcon from "@material-ui/icons/LockOutlined";
import useConfirm from "../../../hooks/useConfirm";
import useNotification from "../../../hooks/useNotification";
import { TYPE_NOTIFICATION } from "../shares/NotificationBull";
import IndicationCreationCompte from "../shares/extra/IndicationCreationCompte";
import { useQuery } from "../../../hooks/useQuery";

const LoginPage = () => {
  const { Toast, showToast } = useToast();
  const [loading, setloading] = useState(false);
  const [submited, setSubmitted] = useState(false);
  const [authData, setAuthData] = useState({ email: "", password: "" });
  const [message, setMessage] = useState("");
  const { DialogComponent, openConfirmDialog } = useConfirm();
  const { NotificationComponent, showNotification } = useNotification();
  const navigate = useNavigate();
  const url = useQuery();
  const [formError, setFormError] = useState({
    mailError: null,
    passwordError: null,
  });
  const isSubmitted = () => {
    return submited;
  };

  const handleActivateAccount = () => {
    openConfirmDialog(
      "Votre compte n'est pas encore activé",
      "Voullez vous activer votre compte?",
      () => handleResendActivationMail(),
      true
    );
  };

  const handleResendActivationMail = () => {
    showToast(TYPE_NOTIFICATION.INFO, "Envoi du lien d'activation...");
    AuthService.resendActivationLink(authData).then((res) => {
      if (res && res.success) {
        showNotification(
          "Information",
          res.message,
          TYPE_NOTIFICATION.INFO,
          () => {}
        );
      }
    });
  };

  const handleSubmit = () => {
    setSubmitted(true);
    setloading(true);
    const isValid = checkDataValidation();
    if (isValid) {
      AuthService.login(authData)
        .then((res) => {
          // alert(res);
          if (res && res.success) {
            setFormError({ mailError: null, passwordError: null });
            navigate(`${url.get("rdr") || "/"}`);
          } else {
            setMessage(res.message);
            if (res.message === "Votre compte n'est pas encore activé") {
              handleActivateAccount();
            }
          }
        })
        .finally((res) => {
          setloading(false);
          // console.log(res);
        });
    } else {
      setloading(false);
    }
  };

  const checkDataValidation = () => {
    if (!isValidEmail(authData.email)) {
      setFormError({
        ...formError,
        mailError: "Veuillez entrer un email valide",
      });
      return false;
    } else {
      setFormError({ ...formError, mailError: null });
      return true;
    }
  };

  useEffect(() => {
    if (AuthService.isConnected()) {
      if (url.get("rdr")) {
        navigate(url.get("rdr"));
        return;
      } else {
        navigate("/");
      }
    }
    checkDataValidation();
  }, []);

  const handleGoToForgotPasswordPage = () => {
    navigate("/forgot-password");
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setAuthData({ ...authData, [name]: value });
    if (name === "email") {
      setFormError({
        ...formError,
        mailError: isValidEmail(value)
          ? null
          : "Veuillez entrer un email valide",
      });
    } else if (name === "password") {
      setFormError({
        ...formError,
        passwordError:
          value.length >= 6
            ? null
            : "Le mot de passe doit contenir au moins 6 caractères",
      });
    }
  };
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        // justifyContent: "center",
        // background: "linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)",
        py: 4,
      }}
    >
      <NotificationComponent />
      <DialogComponent />
      <Toast />
      <Container >
        <Grid container alignItems="center" spacing={4} justifyContent="space-between">
          {/* Section Indication */}
          <Grid item xs={12} md={6}>
            <Box
              sx={{
                p: { md: 4 },
                height: "100%",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
              }}
            >
              <IndicationCreationCompte />
            </Box>
          </Grid>

          {/* Formulaire de Login */}
          <Grid item xs={12} md={5}>
            <Paper
              elevation={1}
              sx={{
                p: { xs: 3, md: 5 },
                // borderRadius: 4,
                // boxShadow: "0 10px 30px rgba(0,0,0,0.1)",
                background: "rgba(255, 255, 255, 0.95)",
                backdropFilter: "blur(10px)",
              }}
            >
              <Grid item xs={12} display={"flex"} justifyContent="center" mb={3}>
                {FID_LOGO}
              </Grid>
              <Typography
                variant="h5"
                component="h1"
                gutterBottom
                sx={{
                  fontWeight: "bold",
                  textAlign: "center",
                  mb: 4,
                  color: "#1a237e",
                }}
              >
                Connectez-vous
              </Typography>
              <Grid
                container
                display={"flex"}
                flexDirection={"column"}
                justifyContent="center"
                alignItems="center"
              >
                <Grid container display={"flex"} flexDirection={"column"} gap={2}>
                  <FormControl fullWidth>
                    <Typography
                      variant="body2"
                      sx={{ mb: 1, fontWeight: 500, color: "#555" }}
                    >
                      Adresse email *
                    </Typography>
                    <TextField
                      id="email"
                      name="email"
                      size="small"
                      placeholder="Adresse email"
                      fullWidth
                      onChange={(e) => handleChange(e)}
                      value={authData.email}
                      error={formError.mailError && isSubmitted()}
                      helperText={
                        formError.mailError && isSubmitted()
                          ? formError.mailError
                          : null
                      }
                      aria-describedby="username_helper"
                      slotProps={{
                        input: {
                          startAdornment: (
                            <InputAdornment position="start">
                              <PermIdentityOutlinedIcon color="action" />
                            </InputAdornment>
                          ),
                        },
                      }}
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          borderRadius: 2,
                        },
                      }}
                    />
                  </FormControl>
                  <FormControl fullWidth>
                    <Typography
                      variant="body2"
                      sx={{ mb: 1, fontWeight: 500, color: "#555" }}
                    >
                      Mot de passe *
                    </Typography>
                    <TextField
                      id="password"
                      name="password"
                      type="password"
                      size="small"
                      placeholder="Mot de passe"
                      fullWidth
                      onChange={(e) => handleChange(e)}
                      value={authData.password}
                      error={message !== "" && isSubmitted()}
                      helperText={message}
                      aria-describedby="pwd_helper"
                      slotProps={{
                        input: {
                          startAdornment: (
                            <InputAdornment position="start">
                              <LockOutlinedIcon color="action" />
                            </InputAdornment>
                          ),
                        },
                      }}
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          borderRadius: 2,
                        },
                      }}
                    />
                  </FormControl>
                </Grid>
                <Grid
                  item
                  display={"flex"}
                  justifyContent="center"
                  alignItems="center"
                  pt={4}
                  width={"100%"}
                >
                  <LoadingButton
                    fullWidth
                    loading={loading}
                    variant="contained"
                    type="submit"
                    onClick={handleSubmit}
                    sx={{
                      py: 1.2,
                      borderRadius: 2,
                      textTransform: "none",
                      fontSize: "1rem",
                      fontWeight: "bold",
                    }}
                  >
                    Se connecter
                  </LoadingButton>
                </Grid>
                <Grid
                  item
                  xs={12}
                  mt={2}
                  width={"100%"}
                  justifyContent={"center"}
                  display={"flex"}
                  flexDirection={"column"}
                >
                  <Button
                    onClick={handleGoToForgotPasswordPage}
                    sx={{
                      textTransform: "none",
                      color: "text.secondary",
                      "&:hover": { backgroundColor: "transparent", textDecoration: "underline" },
                    }}
                  >
                    Mot de passe oublié ?
                  </Button>
                  <Divider sx={{ my: 2 }}>
                    <Typography variant="body2" color="text.secondary">
                      ou
                    </Typography>
                  </Divider>
                </Grid>
                <Grid item xs={12} width={"100%"}>
                  <Link
                    to="/registration"
                    style={{ textDecoration: "none" }}
                  >
                    <Button
                      variant="outlined"
                      color="secondary"
                      fullWidth
                      sx={{
                        py: 1.2,
                        borderRadius: 2,
                        textTransform: "none",
                        fontWeight: "bold",
                      }}
                    >
                      Créer un compte
                    </Button>
                  </Link>
                </Grid>
              </Grid>
            </Paper>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default LoginPage;
